
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    baseInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    // 显示表格细节
    showDetails(itemLine) {
      console.log("itemLine :>> ", itemLine);
      // 当itemLine.attaches数组里有一个有图片的时候就跳转
      const attaches = itemLine.attaches || [];
      const isHasImg = attaches.some(attach => {
        const urls = attach.urls || [];
        return urls.length > 0;
      });
      if (!isHasImg) return;
      this.$router.push({
        name: "tracetagdetail",
        query: { info: JSON.stringify(itemLine) }
      });
    }
  }
});
